import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {URLS} from '../utils/urls';
import {StorageService} from './storage';
import {LoaderService} from './loader';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})


@Injectable({ providedIn: 'root'})

export class AuthService {
  private token: string | undefined | null;
  private tokenTimer: any;
  private userId: string | undefined | null;
  private isAuthenticated = false;

  constructor(private http: HttpClient,
              private router: Router,
              private loader: LoaderService,
              private storageService: StorageService) {}
  /**
   * @param  {string} phoneNumber
   */
  sendOtp(phoneNumber: string) {
    const authData = {phoneNumber: phoneNumber};
    return this.http.post(URLS.SEND_OTP, authData);
  }
  /**
   * Authenticating user
   * @param  {string} phoneNumber
   * @param  {string} otp
   */
  login(phoneNumber: string, otp: string): Observable<VerifyOtpResponse> {
    return this.http.post<VerifyOtpResponse>(URLS.LOGIN, { phoneNumber, otp });
  }

  refreshAccessToken(): Observable<{ accessToken: string }>  {
    const refreshToken = this.getRefreshToken();
    return this.http.post<{ accessToken: string }>(URLS.REFRESH_TOKEN, {refreshToken});
  }


  // /**
  //  * Getting user id
  //  */
  // getUserId() {
  //   return this.userId;
  // }
  /**
   * Logout user
   */
  logout() {
    this.token = null;
    this.isAuthenticated = false;
    this.userId = null;
    this.storageService.clearAuthToken();
    this.storageService.clearRefreshToken();
    this.storageService.clearUser();
    this.router.navigate(['/login']).then(r => console.log("Logged out"));
  }
  // /**
  //  * Getting token
  //  */
  // getToken() {
  //   return this.token;
  // }
  // /**
  //  * Getting and returning authStatusListener Subject as an Observable
  //  */
  // getAuthStatusListener() {
  //   return this.authStatusListener.asObservable();
  // }
  // /**
  //  * Getting isAuthenticated
  //  */
  // getIsAuth() {
  //   return this.isAuthenticated;
  // }
  // /**
  //  * Automatic authenticating user
  //  */
  // autoAuthUser() {
  //   const authInformation = this.getAuthData();
  //   if (!authInformation) {
  //     return;
  //   }
  //   const now = new Date();
  //   const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
  //   if (expiresIn > 0) {
  //     this.token = authInformation.token;
  //     this.isAuthenticated = true;
  //     this.userId = authInformation.userId;
  //     this.setAuthTimer(expiresIn / 1000);
  //     this.authStatusListener.next(true);
  //   }
  // }
  //
  // private setAuthTimer(duration: number) {
  //   this.tokenTimer = setTimeout(() => {
  //     this.logout();
  //   }, duration * 1000);
  // }
  // private saveAuthData(token: string, expirationDate: Date, userId: string) {
  //   localStorage.setItem('token', token);
  //   localStorage.setItem('expiration', expirationDate.toISOString());
  //   localStorage.setItem('userId', this.userId);
  // }
  // private clearAuthData() {
  //   localStorage.removeItem('token');
  //   localStorage.removeItem('expiration');
  //   localStorage.removeItem('userId');
  // }
  // private getAuthData() {
  //   const token = localStorage.getItem("token");
  //   const expirationDate = localStorage.getItem("expiration");
  //   const userId = localStorage.getItem('userId');
  //   if (!token || !expirationDate) {
  //     return;
  //   }
  //   return {
  //     token: token,
  //     expirationDate: new Date(expirationDate),
  //     userId: userId
  //   }
  // }
  getAuthToken() {
    return this.storageService.getAuthToken();
  }

  setAuthToken(token: string) {
    this.storageService.setAuthToken(token);
  }
  getRefreshToken() {
    return this.storageService.getRefreshToken();
  }

  setRefreshToken(token: string) {
    this.storageService.setRefreshToken(token);
  }
  isUserAuthenticated(): boolean {
    if(this.storageService.getAuthToken()) {
      this.isAuthenticated = true;
    }
    return this.isAuthenticated;
  }
  setUserAuthenticated() {
    this.isAuthenticated = true;
  }
}
